import axiosClient from "../api/axiosClient";

export const getEvents = () => axiosClient.get("/Events/GetMyEvent");

export const getSubPromoterEvents = () => axiosClient.get("/Events/GetMySubPromoterEvents");

export const getEventById = (id) => axiosClient.get(`/Events/${id}`);

export const getPromoterDashboard = (config) => axiosClient.get("/Events/promoter", config);
